module.exports = __webpack_public_path__ + "static/fonts/CeraPro-Medium.96761a4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CeraPro-Medium.woff
// module id = SD8Q
// module chunks = 1